<template>
  <div>
    <div style="padding: 5px;" v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: 'agreement',
  data () {
    return {
      idAgree: false,
      content: ''
    }
  },
  methods: {
    loadData (agreementType) {
      let _this = this
      this.$axios.post('/app/agreement/agreement', {type: agreementType})
        .then((res) => {
          if (res.status === 200) {
            _this.content = res.data
          } else {
            _this.$message.error(res.msg)
          }
        })
    }
  },
  mounted () {
    let agreementType = this.$route.params.type || this.$route.query.type
    this.loadData(agreementType)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Agreement.vue